
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0f21c0fe&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewSuggestionFeedback.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewSuggestionFeedback.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0f21c0fe!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewSuggestionFeedback.vue"),
  /* scopeId */
  "data-v-0f21c0fe",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/Participants/NewSuggestionFeedback.vue
// module id = 1846
// module chunks = 61